import "core-js";
import React, { Component } from "react";

import { withFirebase } from "../Firebase";


import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";

import {
  Button,

} from "@blueprintjs/core";

import ReactDataGrid from "react-data-grid";

import { Grid, Row, Col } from "react-flexbox-grid";

import { Link } from "react-router-dom";
import "react-dates/initialize";
import "./index.css";

const {
  Toolbar,
  Filters: {
    AutoCompleteFilter,
    MultiSelectFilter,
    SingleSelectFilter
  },
  Data: { Selectors }
} = require("react-data-grid-addons");
const selectors = Selectors;

class EventsOnly extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      events: [],
      visible_events: [],
      filters: {},
      selectedIndexes: [],
      selectedEvents: [],
      rows: "",
      total_registered: 0,
      total_attended: 0,
      total_walkins: 0,
      total_waitlist: 0
    };
  }

  componentDidMount() {
    var local_events = [];
    this.props.firebase.events().onSnapshot(snapshot => {
      snapshot.forEach(doc => {
        try {
          var event_object = doc.data();
          console.log(event_object);
          event_object.id = doc.id;
          this.props.firebase.getRef(event_object.instructor).then(doc => {
            console.log(doc.data());
            try {
              event_object.owner_name = doc.data().name;
            } catch (err) {
              console.log(err);
              event_object.owner_name = "undefined";
            }
            console.log(event_object);
            local_events.push(event_object);
            this.setState({
              events: local_events,
              visible_events: this.rows(local_events)
            });
            console.log(this.state.events);
          });
        } catch (err) {
          console.log(err);
        }
      });
    });
  }

  getRegisteredCount() {
    var events = this.state.visible_events;
    var i = 0;
    events.forEach(row => {
      if (row.registered !== "not available") {
        i += row.registered;
      }
    });
    return i;
  }

  getAttendedCount() {
    var events = this.state.visible_events;
    var i = 0;
    events.forEach(row => {
      if (row.attended !== "not available") {
        i += row.attended;
      }
    });
    return i;
  }

  getWaitlistCount() {
    var events = this.state.visible_events;
    var i = 0;
    events.forEach(row => {
      if (row.waitlist !== "not available") {
        i += row.waitlist;
      }
    });
    return i;
  }

  getWalkCount() {
    var events = this.state.visible_events;
    var i = 0;
    events.forEach(row => {
      if (row.walk_in !== "not available") {
        i += row.walk_in;
      }
    });
    return i;
  }

  itemRenderer = (bool, event) => {
    console.log(bool, event);
  };

  onItemSelect = event => {
    console.log(event);
  };

  handleGridSort(sortColumn, sortDirection) {
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.rows(this.state.events).slice(0)
        : this.state.visible_events.sort(comparer);
    this.setState({ visible_events: rows });
  }

  handleFilterChange(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    console.log(newFilters);
    this.setState({ filters: newFilters });
  }

  getValidFilterValues(columnId) {
    let values = this.state.visible_events.map(r => r[columnId]);
    console.log(values);
    return values.filter((item, i, a) => {
      return i === a.indexOf(item);
    });
  }

  getRows(rows, filters) {
    console.log(filters);
    return selectors.getRows({ rows, filters });
  }

  handleClearFilters = () => {
    this.setState({ filters: Object.assign({}) });
  };

  onRowsSelected = users => rows => {
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map(r => r.rowIdx)
      ),
      selectedEvents: this.state.selectedEvents.concat(
        rows.map(r => users[r.rowIdx].id)
      )
    });
  };

  onRowsDeselected = users => rows => {
    let rowIndexes = rows.map(r => r.rowIdx);
    let users_email = rows.map(r => users[r.rowIdx].id);
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        i => rowIndexes.indexOf(i) === -1
      ),
      selectedEvents: this.state.selectedEvents.filter(
        i => users_email.indexOf(i) === -1
      )
    });
  };

  cols = [
    {
      key: "check_in",
      name: "Check In",
      width: 100,
      sortable: false,
      resizable: false,
      filterable: false,
      frozen: true
    },
    {
      key: "name",
      name: "Name",
      width: 150,
      filterRenderer: SingleSelectFilter,
      formatter: this.confirme_formatter,
      resizable: true,
      sortable: false,
      filterable: true,
      frozen: true
    },
    {
      key: "id",
      name: "ID",
      width: 100,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: false,
      filterable: true,
      frozen: true
    },
    {
      key: "instructor",
      name: "Instructor",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true
    },

    {
      key: "owner",
      name: "Owner",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },
    {
      key: "program",
      name: "Program",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },

    {
      key: "type",
      name: "Type",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },

    {
      key: "date",
      name: "Date",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_date_formatter,
      resizable: true,
      sortable: true,
      filterable: true
    },
    {
      key: "registered",
      name: "Registered",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_formatter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "attended",
      name: "Attended",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_date_formatter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "walk_in",
      name: "Walk-In",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "waitlist",
      name: "Waitlist",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "stream_views",
      name: "Stream Views",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    }
  ];

  getAttended = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.attended) {
        i++;
      }
    });
    return i;
  };
  getRegistrations = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.confirmed) {
        i++;
      }
    });
    return i;
  };
  getWalkIn = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.walk_in) {
        i++;
      }
    });
    return i;
  };
  getWaitlist = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.waitlist) {
        i++;
      }
    });
    return i;
  };
  rows = events => {
    var list = [];
    console.log(events);
    events.forEach(event => {
      console.log(event);
      var row = {
        id: event.id === undefined ? "not available" : event.id,
        owner:
          event.owner_name === undefined ? "not available" : event.owner_name,
        program: event.program === undefined ? "not available" : event.program,
        name:
          event.event_name === undefined ? "not available" : event.event_name,
        type:
          event.event_type === undefined ? "not available" : event.event_type,
        instructor:
          event.owner_name === undefined ? "not available" : event.owner_name,
        date:
          event.event_date[0] === undefined
            ? "not available"
            : new Date(
                event.event_date[0].date.seconds * 1000
              ).toLocaleDateString(),
        registered:
          event.registrations === undefined
            ? "not available"
            : this.getRegistrations(event.registrations),
        attended:
          event.registrations === undefined
            ? "not available"
            : this.getAttended(event.registrations),
        walk_in:
          event.registrations === undefined
            ? "not available"
            : this.getWalkIn(event.registrations),
        waitlist:
          event.registrations === undefined
            ? "not available"
            : this.getWaitlist(event.registrations),
        stream_views: "feature not yet implemented",
        check_in: (
          <Link to={`/checkin/${event.id}`}>
            <Button fill={true} text="Check-In" />
          </Link>
        )
      };
      list.push(row);
    });
    return list;
  };
  render() {
    var { visible_events, filters } = this.state;
    var filteredRows = this.getRows(visible_events, filters);
    return (
      <Grid>
        <h1>Events</h1>
        <Row>
          <Col xs>
            <ReactDataGrid
              columns={this.cols}
              rowGetter={i => filteredRows[i]}
              rowsCount={this.state.visible_events.length}
              toolbar={<Toolbar enableFilter={true} />}
              onGridSort={(sortColumn, sortDirection) =>
                this.handleGridSort(sortColumn, sortDirection)
              }
              onAddFilter={filter => this.handleFilterChange(filter)}
              getValidFilterValues={colId => this.getValidFilterValues(colId)}
              onClearFilters={() => this.handleClearFilters()}
              rowSelection={{
                showCheckbox: false,
                enableShiftSelect: false,
                onRowsSelected: this.onRowsSelected(this.state.events),
                onRowsDeselected: this.onRowsDeselected(this.state.events),
                selectBy: {
                  indexes: this.state.selectedIndexes
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default withFirebase(EventsOnly);
